
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.25 24a3.754 3.754 0 01-3.75-3.75v-3.473A9.732 9.732 0 019.75 19.5C4.374 19.5 0 15.126 0 9.75S4.374 0 9.75 0s9.75 4.374 9.75 9.75c0 1.84-.518 3.631-1.5 5.187v5.313c0 1.241 1.009 2.25 2.25 2.25s2.25-1.009 2.25-2.25v-1.5a.75.75 0 011.5 0v1.5A3.754 3.754 0 0120.25 24zM9.75 1.5C5.201 1.5 1.5 5.201 1.5 9.75S5.201 18 9.75 18 18 14.299 18 9.75 14.299 1.5 9.75 1.5z"}}),_c('path',{attrs:{"d":"M9.75 12.75c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zM9.75 5.25A.75.75 0 019 4.5v-.75a.75.75 0 011.5 0v.75a.75.75 0 01-.75.75zM9.75 16.5a.75.75 0 01-.75-.75V15a.75.75 0 011.5 0v.75a.75.75 0 01-.75.75zM14.801 13.738a.746.746 0 01-.405-.119l-.631-.405a.751.751 0 01.811-1.262l.631.405a.751.751 0 01-.406 1.381zM5.33 7.667a.746.746 0 01-.405-.119l-.631-.405a.743.743 0 01-.328-.471.748.748 0 011.139-.791l.631.405a.746.746 0 01.225 1.036.747.747 0 01-.631.345zM4.699 13.738a.75.75 0 01-.405-1.381l.631-.405a.745.745 0 011.036.226.75.75 0 01-.226 1.036l-.631.405a.748.748 0 01-.405.119zM14.17 7.667a.75.75 0 01-.405-1.381l.631-.405a.745.745 0 011.036.226.745.745 0 01-.226 1.036l-.631.405a.746.746 0 01-.405.119z"}})])
          )
        }
      }
    